import { defaultOptions } from "./constants/defaultOptions.browser";
import { genericPulseEventDispatcher } from "./lib";
import { defaultSendEventHandler } from "./lib/defaultSendEventHandler.browser";
import type { PulseEventDispatcher } from "./typings";

export const pulseEventDispatcher: PulseEventDispatcher = (
  providerId,
  initialOptions = {}
) => {
  const options = { ...defaultOptions, ...initialOptions };
  options.sendEventHandler ||= defaultSendEventHandler;

  return genericPulseEventDispatcher(providerId, options);
};
